import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.50002 3.66663C4.03978 3.66663 3.66669 4.03972 3.66669 4.49996V11.5C3.66669 11.9602 4.03978 12.3333 4.50002 12.3333H11.5C11.9603 12.3333 12.3334 11.9602 12.3334 11.5V4.49996C12.3334 4.03972 11.9603 3.66663 11.5 3.66663H4.50002ZM2.66669 4.49996C2.66669 3.48744 3.4875 2.66663 4.50002 2.66663H11.5C12.5126 2.66663 13.3334 3.48744 13.3334 4.49996V11.5C13.3334 12.5125 12.5126 13.3333 11.5 13.3333H4.50002C3.4875 13.3333 2.66669 12.5125 2.66669 11.5V4.49996Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.25221 5.39902C6.40815 5.31004 6.59982 5.31149 6.75438 5.40283L10.4211 7.5695C10.5733 7.65945 10.6667 7.82313 10.6667 7.99996C10.6667 8.17679 10.5733 8.34046 10.4211 8.43042L6.75438 10.5971C6.59982 10.6884 6.40815 10.6899 6.25221 10.6009C6.09628 10.5119 6.00002 10.3462 6.00002 10.1666V5.83329C6.00002 5.65376 6.09628 5.488 6.25221 5.39902ZM7.00002 6.70952V9.2904L9.18385 7.99996L7.00002 6.70952Z"
      fill="currentColor"
    />
  </SvgIcon>
));
